import React, { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useStateAuthContext, useStateHostContext } from '../context'
import { FaTrashAlt } from 'react-icons/fa';
import { error, success } from '../notify'

const Opd_pengguna_kendaraan = () => {
      window.document.title = "Pengguna Kendaraan"

      const direct = useNavigate();
      const { HOST } = useStateHostContext();
      const { STATE_AUTH } = useStateAuthContext();
      const [pengguna, set_pengguna] = React.useState([]);
      const [is_get_data, set_is_data] = React.useState(false);
      const [showModal, setShowModal] = useState(false);
      const [penggunaToDelete, setPenggunaToDelete] = useState(null);
      const [isDeleting, setIsDeleting] = useState(false);

      React.useEffect(() => {
            set_is_data(true)
            const ambilDataPengguna = async () => {
                  const param = {
                        method: 'GET',
                        headers: {
                              'REST-TOKEN': STATE_AUTH.token,
                              'REST-ID-OPD': STATE_AUTH.id_opd
                        }
                  }
                  const resp = await fetch(HOST + '/user/kendaraan/pengguna', param)
                  try {
                        const resu = await resp.json()
                        set_pengguna(resu.d)
                        set_is_data(false)
                  } catch (e) {
                        error({ msg: 'Masalah ditemukan : ' + e })
                        set_is_data(false)
                  }
            }
            ambilDataPengguna()
      }, [STATE_AUTH, HOST])

      const handleDelete = async () => {
            if (!penggunaToDelete) return;
            setIsDeleting(true);

            try {
                  const param = {
                        method: 'POST',
                        headers: {
                              'REST-TOKEN': STATE_AUTH.token,
                              'REST-ID-OPD': STATE_AUTH.id_opd
                        }
                  };

                  const resp = await fetch(`${HOST}/user/kendaraan/pengguna/hapus/${penggunaToDelete.id}`, param);

                  if (resp.ok) {
                        success({ msg: 'Pengguna kendaraan berhasil dihapus' });
                        setIsDeleting(false);
                        set_is_data(true);
                        const ambilDataPengguna = async () => {
                              const param = {
                                    method: 'GET',
                                    headers: {
                                          'REST-TOKEN': STATE_AUTH.token,
                                          'REST-ID-OPD': STATE_AUTH.id_opd
                                    }
                              }
                              const resp = await fetch(HOST + '/user/kendaraan/pengguna', param)
                              try {
                                    const resu = await resp.json()
                                    set_pengguna(resu.d)
                                    set_is_data(false)
                              } catch (e) {
                                    error({ msg: 'Masalah ditemukan : ' + e })
                                    set_is_data(false)
                              }
                        }
                        ambilDataPengguna();
                  } else {
                        error({ msg: 'Gagal menghapus pengguna kendaraan' });
                  }
            } catch (e) {
                  error({ msg: 'Terjadi kesalahan saat menghapus pengguna kendaraan: ' + e });
            }

            setShowModal(false);
            setPenggunaToDelete(null);
      };

      const loadSpiners = (<div className="spinner-border text-center" role="status">
            <span className="visually-hidden">Loading...</span>
      </div>)

      if (!STATE_AUTH.is_login) {
            return <Navigate to='/' />
      }
      return (
            <main>
                  <div className="container-fluid">

                        <div className="row mt-3">
                              <div className="col-md-12">
                                    <h3><strong><i className='fa fa-user-alt'></i> DAFTAR PENGGUNA KENDARAAN</strong></h3>
                              </div>
                        </div>
                        {
                              STATE_AUTH.is_verifikator === 'tidak'
                                    ?
                                    <>
                                          <hr />
                                          <button className='btn btn-primary btn-sm' onClick={() => { direct('/opd/pengguna/kendaraan/tambah') }}>+ Tambah</button>
                                          <hr />
                                    </>
                                    :
                                    <hr />
                        }
                        <div className="row mt-2">
                              <div className="col-md-12">
                                    <table className='tb-daftar-dinas' style={{ fontSize: '14px', width: '100%' }} cellPadding={5} cellSpacing={0}>
                                          <thead>
                                                <tr>
                                                      <th width="2%">#</th>
                                                      <th>NIP</th>
                                                      <th>NAMA PENGGUNA</th>
                                                      <th>JABATAN</th>
                                                      <th width="10%">AKSI</th>
                                                </tr>
                                          </thead>
                                          <tbody>
                                                {
                                                      is_get_data
                                                            ?
                                                            <tr><td colSpan={5} className='text-center fw-bold'>{loadSpiners}</td></tr>
                                                            :
                                                            pengguna.length !== 0
                                                                  ?
                                                                  pengguna.map((v, i) => {
                                                                        return (<tr key={i}>
                                                                              <td>{i + 1}</td>
                                                                              <td>{v.nip}</td>
                                                                              <td>{v.nama}</td>
                                                                              <td>{v.jabatan}</td>
                                                                              <td>
                                                                                    {v.status_menggunakan !== 'ya' && (
                                                                                          <button
                                                                                                className="btn btn-danger btn-sm"
                                                                                                onClick={() => {
                                                                                                      setPenggunaToDelete(v);
                                                                                                      setShowModal(true);
                                                                                                }}
                                                                                                disabled={STATE_AUTH.is_verifikator === 'ya'}
                                                                                          >
                                                                                                <FaTrashAlt />
                                                                                          </button>
                                                                                    )}
                                                                              </td>
                                                                        </tr>)
                                                                  })
                                                                  :
                                                                  <tr><td className='text-center' colSpan={5}>(Pengguna kendaraan tidak tersedia.)</td></tr>
                                                }
                                          </tbody>
                                    </table>
                              </div>
                        </div>

                        {/* Delete Confirmation Modal */}
                        {showModal && (
                              <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                                    <div className="modal-dialog">
                                          <div className="modal-content">
                                                <div className="modal-header">
                                                      <h5 className="modal-title">Konfirmasi Hapus</h5>
                                                      <button
                                                            type="button"
                                                            className="btn-close"
                                                            onClick={() => {
                                                                  setShowModal(false);
                                                                  setPenggunaToDelete(null);
                                                            }}
                                                      ></button>
                                                </div>
                                                <div className="modal-body">
                                                      <p>Apakah Anda yakin ingin menghapus pengguna kendaraan berikut?</p>
                                                      <p><strong>Nama:</strong> {penggunaToDelete?.nama}</p>
                                                      <p><strong>NIP:</strong> {penggunaToDelete?.nip}</p>
                                                </div>
                                                <div className="modal-footer">
                                                      <button
                                                            type="button"
                                                            className="btn btn-secondary"
                                                            onClick={() => {
                                                                  setShowModal(false);
                                                                  setPenggunaToDelete(null);
                                                            }}
                                                      >
                                                            Batal
                                                      </button>
                                                      <button
                                                            type="button"
                                                            className="btn btn-danger"
                                                            onClick={handleDelete}
                                                            disabled={isDeleting}
                                                      >
                                                            {isDeleting ? (
                                                                  <>
                                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                        &nbsp;Menghapus...
                                                                  </>
                                                            ) : (
                                                                  'Hapus'
                                                            )}
                                                      </button>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        )}
                  </div>
            </main>
      )
}

export default Opd_pengguna_kendaraan